import React from 'react'
import PropTypes from 'prop-types'
import PartyHorn from 'hec/assets/icons/party-horn'
import {Heading} from '@/components/ui/heading'
import {BodyCopy} from '@/components/ui/body-copy'

const PassedQuizBlock = ({moduleTitle}) => (
    <div
        className="flex flex-col items-center py-[3.25rem] bg-active/30 rounded-md"
        name="quiz-block-result"
    >
        <PartyHorn />
        <Heading
            tag="h4"
            variant="h4"
            className="mt-5 mb-2 text-emphasis"
            data-testid="passedQuizBlock-Heading"
        >
            Congratulations!
        </Heading>
        <BodyCopy size="large" className="text-emphasis" data-testid="passedQuizBlock-BodyCopy">
            {'You completed'} {moduleTitle}
        </BodyCopy>
    </div>
)

PassedQuizBlock.propTypes = {
    moduleTitle: PropTypes.string.isRequired
}

export default PassedQuizBlock
